import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	addresses__street__add: 'mw/addresses/street/add',
};

export const addressesApi = createApi({
	reducerPath: 'addressesApi',

	endpoints: (builder) => ({
		addressesStreetAdd: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/addresses/street/add',
				body,
				jsonType: true,
			}),
			providesTags: [tags.addresses__street__add],
		}),
	}),
});

export const {
	addressesStreetAdd,
} = addressesApi.endpoints;

export default addressesApi;